import type { VrCaptureRequestPayload } from '@indutrust/factory-model';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

/**
 * Workflow events for submitting an assisted VR capture booking via
 * {@link VrCaptureRequestApiClient.create}.
 */
export const vrCaptureRequestEvents = eventGroup({
  source: 'factory.vrCaptureRequest',
  events: {
    submitRequested: type<{
      factoryId: number;
      payload: VrCaptureRequestPayload;
    }>(),
    submitSucceeded: type<void>(),
    submitFailed: type<{ error: string }>(),
  },
});
